// extracted by mini-css-extract-plugin
export default {"finish":"Finish_finish__nCp6i"};